import { render, staticRenderFns } from "./OtherLogin.vue?vue&type=template&id=53341dbd&scoped=true&"
import script from "./OtherLogin.vue?vue&type=script&lang=js&"
export * from "./OtherLogin.vue?vue&type=script&lang=js&"
import style0 from "./OtherLogin.vue?vue&type=style&index=0&id=53341dbd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53341dbd",
  null
  
)

/* custom blocks */
import block0 from "./OtherLogin.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports